import { isDesktop } from "react-device-detect";
import { Colors } from "../../utils/colors";
import { capitalizeFirstLetter } from "@markit/common.utils";

/* --- Header Component for explore page and each subpage --- */
/*
 * Takes in a title and description. If neither are defined, defaults to
 * explore page title/description.
 */

type ExploreHeroProps = {
  title?: string;
  description?: string;
};

const ExploreHero = (props: ExploreHeroProps) => {
  const { title, description } = props;

  const styles = {
    heroContainer: {
      paddingTop: isDesktop ? 100 : 80,
      gap: 20,
    },

    heroText: {
      fontSize: isDesktop ? 64 : 45,
      color: Colors.WHITE,
      fontWeight: 600,
    },

    heroSubtext: {
      fontSize: isDesktop ? 22 : 14,
      color: Colors.GRAY14,
    },

    heroLabel: {
      fontSize: isDesktop ? 20 : 14,
      color: Colors.BLUE5,
      fontWeight: 500,
    },
  };

  return (
    <div
      className={description ? "ColumnNormal" : "AlignedColumn"}
      style={styles.heroContainer}
    >
      <div className="ColumnNormal" style={{ gap: isDesktop ? 10 : 7 }}>
        {description ? (
          <span style={styles.heroLabel}>Browse by Category</span>
        ) : null}
        <span style={styles.heroText}>
          {title ? capitalizeFirstLetter(title) : "Explore"}
        </span>
      </div>
      <span style={styles.heroSubtext}>
        {description ??
          "Discover and subscribe to your favorite creators and brands"}
      </span>
    </div>
  );
};

export default ExploreHero;
